// extracted by mini-css-extract-plugin
export var dividerContainer = "_9d-0";
export var line = "_9d-1";